// extracted by mini-css-extract-plugin
module.exports = {"m1oixje6":"m1oixje6","bordered":"bordered","sticky":"sticky"};